import { angularServicesNames } from "@topline/services/angularServicesNames";
import { IdSvrAuthService } from "../../../auth/idSrvAuthService";
import { ForecastService } from "../services/forecastService";

(function (module) {
    "use strict";

    module.component('forecastUpdate', {
        template: require('./forecastUpdateComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: ['$scope', angularServicesNames.$translate, ForecastService.componentName, IdSvrAuthService.componentName,
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                forecastService: ForecastService,
                authService: IdSvrAuthService
            ) {
                var $ctrl = this;
                $ctrl.forecastService = forecastService;

                $ctrl.$onInit = () => {
                    $ctrl.entity = $ctrl.resolve.entity;
                    $ctrl.forecastService.get($ctrl.entity.id).then((response: $TSFixMe) => {
                        $ctrl.forecast = response.data.jsonData;
                        $ctrl.comment = response.data.correctionComment;
                        authService.getCurrentUserProfile().then((profile) => $ctrl.assignedPerson = profile?.FullName);
                    });
                };

                $scope.$watch('$ctrl.selectedBrand', (data: $TSFixMe) => {
                    $ctrl.tableData = $ctrl.labels = null;
                    if (!$ctrl.forecast || !data) {
                        return;
                    }

                    
                    $ctrl.match = _.find($ctrl.forecast.market.brands, (brand: $TSFixMe) => brand.name === data.name);


                    if (angular._get($ctrl, 'match.customData.values', false)) {
                        const originalValues = $ctrl.match.customData.values.originalValues;
                        const customValues = $ctrl.match.customData.values.customValues;
                        $ctrl.labels = $ctrl.match.customData.values.labels;

                        $ctrl.tableData = [
                            { header: $translate.instant('FORECAST.PRODUCT.DEFENCE.PRODUCT_FORECAST'), data: originalValues, isReadOnly: true },
                            { header: $translate.instant('FORECAST.PRODUCT.DEFENCE.PRODUCT_DEFENCE'), data: customValues, isReadOnly: false }
                        ];
                    }
                });

                $ctrl.onFocus = ($event: $TSFixMe, item: $TSFixMe, row: $TSFixMe, index: $TSFixMe) => {

                    if (angular.isUndefinedOrNull(row.data[index])) {
                        row.data[index] = $ctrl.tableData[0].data[index].toFixed(2);
                    };
                }

                $ctrl.isDataValid = (data: $TSFixMe) => {
                    if (!data) {
                        return false;
                    }


                    const brands = angular._get(data, 'market.brands', []);
                    return brands

                        .filter((x: $TSFixMe) => angular._get(x, 'customData.values.customValues', false))
                        .map((x: $TSFixMe) => x.customData.values.customValues)

                        .some((x: $TSFixMe) => x.some((x: $TSFixMe) => !angular.isUndefinedOrNull(x)));
                }

                $ctrl.ok = function () {
                    if ($ctrl.isDataValid($ctrl.forecast)) {
                        $ctrl.close({
                            $value: { jsonData: $ctrl.forecast, comment: $ctrl.comment }
                        });
                    }
                };

                $ctrl.cancel = function () {
                    $ctrl.dismiss({
                        $value: 'cancel'
                    });
                };
            }]
    })

})(angular.module('topline.modules'));